import styled from 'styled-components';
import { Link } from 'react-router-dom';

const InternalLink = styled(Link)<{ $disabled?: boolean }>`
  color: ${({ theme, $disabled }) =>
    $disabled ? theme.palette.common.gray11 : theme.palette.common.blue4};
  pointer-events: ${({ $disabled }) => ($disabled ? 'none' : 'auto')};
`;

export default InternalLink;
